import { createAction } from '@reduxjs/toolkit';
import { AppThunk } from '../../store';
import { IUser } from '../../../interfaces/user';
import { listAdminAvailableUsers } from '../../../services/DevPortalService';

// Actions

export const getAdminUserError = createAction<string>('GET_ADMIN_USERS_ERROR');
export const resetAdminDevelopers = createAction('RESET_ADMIN_USERS');

// Thunk Actions

export const getAdminUsersAction = createAction<IUser[] | undefined>('GET_ADMIN_USERS');
export const getAdminAvailableUsers = (): AppThunk => async (dispatch, getState) => {
  try {
    const take = 1000;
    const skip = 0;

    const currentUsers = getState().adminUserReducer.developers;

    if (currentUsers && currentUsers?.length > 0) return;

    const res = await listAdminAvailableUsers(take, skip);

    if (res.parsedBody) {
      return dispatch(getAdminUsersAction(res.parsedBody));
    }
  } catch (e) {
    return dispatch(getAdminUserError('Error fetching users.'));
  }
};
